import React from 'react';
import Select from 'react-select';
import NoSsr from '@mui/material/NoSsr';
import { components, useStyle } from './AutocompliteComponents'

/** 
 * @param {import("./types/Autocomplite").Autocomplite} param0 
 */
export default function Autocomplite({
  arr,
  palaceHolder,
  value,
  action,
  selectProps = {},
  textFieldProps = {}
}) {
  const classes = useStyle()
  const finalTextFieldProps = {
    label: palaceHolder,
    InputLabelProps: {
      shrink: true,
    },
    ...textFieldProps // Раскрываем внешние пропсы
  };
  if (textFieldProps && textFieldProps.label === undefined) {
    delete finalTextFieldProps.label; 
  }
  return <div className={classes.root}>
    <NoSsr>
      <Select
        classes={classes}
        options={arr}
        textFieldProps={finalTextFieldProps}
        components={components}
        value={value}
        onChange={value => action(value)}
        placeholder={palaceHolder}
        native
        {...selectProps}
      />
    </NoSsr>
  </div>
}